import { Eleve } from '@teetsh/app/src/types/eleves';
import { orderByNiveau } from './orderByNiveau';

export function getDistinctEleveGroups(
  eleves: Eleve[],
  additionalGroups?: string[],
): string[] {
  const flattenGroupNames = eleves
    .flatMap(({ groupNames = [], classroomNames = [] }) => [
      ...groupNames,
      ...classroomNames,
    ])
    .concat(additionalGroups || [])
    .filter(v => !!v.trim());
  const uniqueGroups = [...new Set(flattenGroupNames)];

  return orderByNiveau(uniqueGroups);
}
